const formatRelativeDate = (dateInput: Date | string) => {
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;

  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  if (isSameDay(date, today)) {
    return 'Today';
  }

  if (isSameDay(date, yesterday)) {
    return 'Yesterday';
  }

  return date.toLocaleDateString('en-US', {month: 'long', day: 'numeric'});
};

// Helper to check if two dates are the same day
const isSameDay = (d1: Date, d2: Date) =>
  d1.getFullYear() === d2.getFullYear() &&
  d1.getMonth() === d2.getMonth() &&
  d1.getDate() === d2.getDate();

export const groupTranscriptByDate = (
  transcripts: any[],
  sortType: 'created' | 'modified',
  isNewestFirst: boolean
) => {
  const groups: Record<string, {items: any[]; sortDate: number}> = {};
  transcripts.forEach((item) => {
    const itemDate =
      sortType === 'modified'
        ? new Date(item.updatedDate)
        : new Date(item.createdDate);
    const relativeDate = formatRelativeDate(itemDate);
    if (!groups[relativeDate]) {
      groups[relativeDate] = {
        items: [],
        sortDate: itemDate.getTime(),
      };
    }
    groups[relativeDate].items.push({
      ...item,
    });
  });
  Object.values(groups).forEach((group) => {
    group.items.sort((a, b) => {
      const aDate =
        sortType === 'modified'
          ? new Date(a.updatedDate).getTime()
          : new Date(a.createdDate).getTime();
      const bDate =
        sortType === 'modified'
          ? new Date(b.updatedDate).getTime()
          : new Date(b.createdDate).getTime();
      return isNewestFirst ? bDate - aDate : aDate - bDate;
    });
  });
  return groups;
};

export const formatToCustomUTC = (
  dateString: string,
  options?: {separator?: string}
) => {
  const separator = options?.separator ?? ' ';
  const date = new Date(dateString);

  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');

  let hours = date.getUTCHours();
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');

  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  const hoursStr = String(hours).padStart(2, '0');

  return `${year}/${month}/${day}${separator}${hoursStr}:${minutes}${ampm} UTC`;
};

export const formatLastModifiedUtc = (value?: string | null) => {
  if (!value) return '';
  const raw = value.trim();
  if (!raw) return '';
  const normalized = raw.replace('T', ' ').replace('Z', '');
  const [datePart = '', timeWithMs = ''] = normalized.split(' ');
  const [yyyy = '', mm = '', dd = ''] = datePart.split('-');
  const timePart = timeWithMs.split('.')[0];
  const [hh = '00', min = '00'] = timePart.split(':');
  if (!yyyy || !mm || !dd) return raw;

  // Convert to 12-hour format with AM/PM
  let hourNum = parseInt(hh, 10);
  const ampm = hourNum >= 12 ? 'PM' : 'AM';
  hourNum = hourNum % 12 || 12;
  const hourStr = String(hourNum).padStart(2, '0');

  return `${yyyy}/${mm}/${dd} - ${hourStr}:${min}${ampm} UTC`;
};
